<section class="flex flex-column consult__section" *ngIf="value && value.length > 0">
  <div class="col-12 inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label for="{{name}}" class="field__label no-margin">{{screen.labels.extraQuestion}}</label>
    </h2>
    <span class="consult__section-help"></span>
  </div>

  <ng-container *ngIf="value">
    <div class="col-12 px-0 inline-flex flex-wrap col-12" *ngFor="let item of value">
      <label class="col-3 py-0 pl-0">{{item.question}}</label>
      <div class="col-9 px-0 inline-flex consult__section-input-group">
        <textarea pInputTextarea name="{{name}}__{{item.id}}" [(ngModel)]="item.answer" [rows]="2" validation
          [required]="item.required ?? false" class="uppercase no-margin"></textarea>
      </div>
    </div>
  </ng-container>
</section>
